var dateUtils = {};

dateUtils.getLocalOffset = function () {
  var date = new Date();
  // Return local timezone offset in seconds
  return date.getTimezoneOffset() * (-60);
};

module.exports = dateUtils;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/util/date-utils.js
// module id = 1680
// module chunks = 6